import { LoginSchema } from 'commons/login';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';

export const useLoginFormSchema = () => {
  const { t } = useTranslationWithLang('commons');

  const schema = LoginSchema({
    LengthMessage: (max: number) => t('Validate_MaxLength', { max }),
    RequiredMessage: t('Validate_Required'),
    NoFullWidthMessage: t('Validate_NoFullWidth'),
  });
  return schema;
};
